// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-modal {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.profile-modal .img-div {
  position: relative;
  width: 250px;
  height: 250px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
}
.profile-modal .img-div img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Dark semi-transparent overlay */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-size: 16px;
  font-weight: bold;
  border-radius: 50%;
}

.img-div:hover .upload-overlay {
  opacity: 1;
}
.profile-modal p {
  /* border: 1px solid red; */
  /* margin-right: auto;
  margin-left: auto; */
  font-family: Karla;
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  padding: 0;
  margin: 0;
}
.profile-modal .start {
  margin-right: 0;
  margin-left: 0;
}
.profile-modal .center-text {
  margin-right: auto;
  margin-left: auto;
}

.profile-modal .content-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.profile-modal .content-info p {
  display: flex;
  gap: 30px;
  padding: 10px 0;
}

.profile-modal .btns {
  height: 50px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  text-transform: none;
  border: 1px solid;
  color: inherit;
  border-color: inherit;
}

.profile-modal .btn-default {
  color: #444444;
  border-color: #444444;
}

.profile-modal .btn-default:hover {
  color: #444444;
  border-color: #444444;
  background-color: #ffffff;
}

.profile-modal .btns-green {
  border-color: #50c878;
  color: #50c878;
}

.profile-modal .btns-green:hover {
  border-color: #50c878;
  background-color: #50c878;
  color: white;
}

.profile-modal .btns-red {
  border-color: #e77b7b;
  color: #e77b7b;
}

.profile-modal .btns-red:hover {
  border-color: #e77b7b;
  background-color: #e77b7b;
  color: white;
}

.profile-modal hr {
  width: 100%;
  color: #000000;
}

.profile-modal .Error-msg {
  font-family: Poppins;
  font-weight: 400;
  font-size: 18px;
  color: #e77b7b;
}
`, "",{"version":3,"sources":["webpack://./src/features/Setting/profile/components/profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,kCAAkC;EACxE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B;sBACoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".profile-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n.profile-modal .img-div {\n  position: relative;\n  width: 250px;\n  height: 250px;\n  margin-right: auto;\n  margin-left: auto;\n  overflow: hidden;\n  display: inline-block;\n  cursor: pointer;\n}\n.profile-modal .img-div img {\n  border-radius: 50%;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.upload-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6); /* Dark semi-transparent overlay */\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 50%;\n}\n\n.img-div:hover .upload-overlay {\n  opacity: 1;\n}\n.profile-modal p {\n  /* border: 1px solid red; */\n  /* margin-right: auto;\n  margin-left: auto; */\n  font-family: Karla;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 22px;\n  padding: 0;\n  margin: 0;\n}\n.profile-modal .start {\n  margin-right: 0;\n  margin-left: 0;\n}\n.profile-modal .center-text {\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.profile-modal .content-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.profile-modal .content-info p {\n  display: flex;\n  gap: 30px;\n  padding: 10px 0;\n}\n\n.profile-modal .btns {\n  height: 50px;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 22px;\n  text-transform: none;\n  border: 1px solid;\n  color: inherit;\n  border-color: inherit;\n}\n\n.profile-modal .btn-default {\n  color: #444444;\n  border-color: #444444;\n}\n\n.profile-modal .btn-default:hover {\n  color: #444444;\n  border-color: #444444;\n  background-color: #ffffff;\n}\n\n.profile-modal .btns-green {\n  border-color: #50c878;\n  color: #50c878;\n}\n\n.profile-modal .btns-green:hover {\n  border-color: #50c878;\n  background-color: #50c878;\n  color: white;\n}\n\n.profile-modal .btns-red {\n  border-color: #e77b7b;\n  color: #e77b7b;\n}\n\n.profile-modal .btns-red:hover {\n  border-color: #e77b7b;\n  background-color: #e77b7b;\n  color: white;\n}\n\n.profile-modal hr {\n  width: 100%;\n  color: #000000;\n}\n\n.profile-modal .Error-msg {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 18px;\n  color: #e77b7b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
